<div id="howToUse" class="how-use pt-100">
    <div class="container">
        <div class="section-title">
            <span>كيف تعمل</span>
            <h2>
                4 خطوات بسيطة يجب اتباعها
                <!-- 4 Simple Steps to Follow -->
            </h2>
            <p>
                إليك برنامج تعليمي حول كيفية تشغيل هذا التطبيق بسهولة وبدون عناء
                لرفع قضيتك . إتبع التعليمات المقدمة.
                <!-- Here is a tutorial on how you can operate this app easily and effortlessly reserve your tickets for your awaited trip. Follow the given instruction. -->
            </p>
        </div>
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="row align-items-center">
                    <div
                        class="col-lg-6 col-md-6 col-sm-6 wow fadeInUp"
                        data-wow-duration="1s"
                    >
                        <div class="how-use-card how-card-one">
                            <span>1</span>
                            <i class="flaticon-coding"></i>
                            <h3>
                                حمل التطبيق
                                <!-- Installation First -->
                            </h3>
                        </div>
                    </div>
                    <div
                        class="col-lg-6 col-md-6 col-sm-6 wow fadeInUp"
                        data-wow-duration="1s"
                    >
                        <p>
                            حمل التطبيق بسهولة على جهازك من متجر التطبيقات أو قم
                            بتنزيله عبر الإنترنت.
                            <!-- Easily install the app in your device from the app store or download it online. -->
                        </p>
                    </div>
                    <div
                        class="col-lg-6 col-md-6 col-sm-6 wow fadeInUp"
                        data-wow-duration="1s"
                    >
                        <p>
                            سجل بياناتك ومعلوماتك في التطبيق لمساعدتنا في التعرف
                            عليك.
                            <!-- Give your identification and information in the app to help us recognize you. -->
                        </p>
                    </div>
                    <div
                        class="col-lg-6 col-md-6 col-sm-6 wow fadeInUp"
                        data-wow-duration="1s"
                    >
                        <div class="how-use-card how-card-two">
                            <span>2</span>
                            <i class="flaticon-settings"></i>
                            <h3>
                                سجل بياناتك
                                <!-- Set Your Profile -->
                            </h3>
                        </div>
                    </div>
                    <div
                        class="col-lg-6 col-md-6 col-sm-6 wow fadeInUp"
                        data-wow-duration="1s"
                    >
                        <div class="how-use-card how-card-three">
                            <span>3</span>
                            <!-- <i class="flaticon-map"></i> -->
                            <i class="icofont-list"></i>
                            <h3>
                                إنشاء قضية
                                <!-- Set Destination -->
                            </h3>
                        </div>
                    </div>
                    <div
                        class="col-lg-6 col-md-6 col-sm-6 wow fadeInUp"
                        data-wow-duration="1s"
                    >
                        <p>
                            قم بإنشاء قضيتك و أدخال كافه البيانات المطلوب حتي
                            يتم تسجل قضيتك علي التطبيق
                            <!-- Type your destination and also put the date of when you want to leave for the destination. -->
                        </p>
                    </div>
                    <div
                        class="col-lg-6 col-md-6 col-sm-6 wow fadeInUp"
                        data-wow-duration="1s"
                    >
                        <p>
                            أخيراً، بعد إنشاء القضية يمكن متابعة قضيتك و رايت ما
                            إذا كان احدهم تعرف علي الشخص المفقد المبلغ عنه
                            <!-- Finally, pay your bill and confirm your booking for the ticket and the ticket will be all yours. -->
                        </p>
                    </div>
                    <div
                        class="col-lg-6 col-md-6 col-sm-6 wow fadeInUp"
                        data-wow-duration="1s"
                    >
                        <div class="how-use-card how-card-four">
                            <span>4</span>
                            <i class="icofont-holding-hands"></i>
                            <!-- <i class="flaticon-ticket"></i> -->
                            <h3>
                                تابع قضيتك
                                <!-- Book Your Ticket -->
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="col-lg-4 offset-lg-2 wow fadeInUp"
                data-wow-duration="1s"
            >
                <div class="how-use-slider">
                    <owl-carousel-o [options]="howToUseSlider">
                        <ng-template carouselSlide>
                            <div class="how-use-img">
                                <img
                                    src="assets/img/app-landing/img_1.jpeg"
                                    alt="iphone"
                                />
                            </div>
                        </ng-template>
                        <ng-template carouselSlide>
                            <div class="how-use-img">
                                <img
                                    src="assets/img/app-landing/img_2.jpeg"
                                    alt="iphone"
                                />
                            </div>
                        </ng-template>
                        <ng-template carouselSlide>
                            <div class="how-use-img">
                                <img
                                    src="assets/img/app-landing/img_3.jpeg"
                                    alt="iphone"
                                />
                            </div>
                        </ng-template>
                    </owl-carousel-o>
                </div>
            </div>
        </div>
    </div>
</div>
